import React from 'react';
import Picture from "../shared/components/Picture";

function MatchHubHeaderLoader() {
  return (
    <div role="region" className={`mls-o-match-hub-header`}>
      <div className="mls-o-match-strip mls-o-match-strip--post mls-o-match-strip--matches mls-o-match-strip--loading">
        <div className="mls-o-match-strip__match">
          <div className="mls-o-match-strip__header">
            <div className="mls-o-match-strip__match-info">
              <div className="mls-o-match-strip__match-title">
                <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--3rem" />
              </div>
              <div className="mls-o-match-strip__venue">
                <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--4rem" />
              </div>
            </div>
            <div className="mls-o-sponsor">
              <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--2rem" />
            </div>
          </div>
          <div className="mls-o-match-strip__club-group">
            <div className="mls-o-match-strip__club mls-o-match-strip__club--home ">
              <div className="mls-o-match-strip__club-name">
                <span className="mls-o-match-strip__club-logo">
                  <Picture extraClasses="mls-o-loading mls-o-loading--glow"
                    src="/assets/images/Fallbacklogo-grey.png" title={"fallback_logo"} />
                </span>
                <span className="mls-o-match-strip__club-short-name">
                  <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--4rem" />
                </span>
              </div>
            </div>
            <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--2rem" />
            <div className="mls-o-match-strip__club mls-o-match-strip__club--away ">
              <div className="mls-o-match-strip__club-name">
                <span className="mls-o-match-strip__club-logo">
                  <Picture extraClasses="mls-o-loading mls-o-loading--glow"
                    src="/assets/images/Fallbacklogo-grey.png" title={"fallback_logo"} />
                </span>
                <span className="mls-o-match-strip__club-short-name">
                  <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--4rem" />
                </span>
              </div>
            </div>
          </div>
          <div className="mls-o-match-strip__cta-wrapper">
            <div data-testid={"loading"} className="mls-o-loading mls-o-loading--glow mls-o-loading--line mls-o-loading--5rem" />
          </div>
        </div>
        <div className="mls-o-match-hub-header__background" />
      </div>
    </div>
  );
}

export default MatchHubHeaderLoader;
